import { faImage, faPaperclip, faPaperPlane, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { dispDateHour, getDomain, tempAlWait } from "../helpers";
import { getContact, saveCoord, sendContact } from "../actions/contact";
import Alert from "./Alert";
import { connect } from "react-redux";

class Tchat extends React.Component {
    state = {
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        messs: [],
        form: {
            message: '',
            file: '',
        },
        formCoord: {
            name: '',
            email: ''
        },
        isSendCoord: false,
        prevHour: null,
        activeFocusName: false,
        activeFocusEmail: false
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.openMessage != this.props.openMessage) {
            if (this.props.openMessage) {
                // Récupération des messages
                this.props.getContact();
                this.setState({
                    alert: tempAlWait()
                });
            }
        }
        if (this.props.redListCtct != prevProps.redListCtct) {
            this.setState({
                alert: this.props.redListCtct.alert,
                messs: this.props.redListCtct.datas
            })
        }

        if (this.props.redSendCtct != prevProps.redSendCtct) {
            if (this.props.redSendCtct.isNext) {
                this.setState({
                    alert: tempAlWait(),
                    form: {
                        message: '',
                        file: ''
                    }
                });
                this.props.getContact();
            } else {
                this.setState({
                    alert: this.props.redSendCtct.alert
                });
            }
        }

        if (this.props.redSaveCoord != prevProps.redSaveCoord) {
            if (this.props.redSaveCoord.alert.type == "succ") {
                this.setState({
                    alert: this.props.redSaveCoord.alert,
                    isSendCoord: true
                })
            } else {
                this.setState({
                    alert: this.props.redSaveCoord.alert
                })
            }
        }

        if (prevState.alert != this.state.alert) {
            this.props.changeAlert(this.state.alert);
        }
    }

    handleSend(el) {
        el.preventDefault();
        this.props.sendContact({
            message: this.state.form.message,
            file: this.state.form.file
        });
        this.setState({
            alert: tempAlWait()
        })
    }

    handleSaveCoord(el) {
        el.preventDefault();
        this.props.saveCoord({
            email: this.state.formCoord.email,
            name: this.state.formCoord.name
        })
        this.setState({
            alert: tempAlWait()
        })
    }

    espaceTime20(date, prevHour) {
        const d1 = new Date(date);
        const d2 = new Date(prevHour);

        const diffMs = Math.abs(d2 - d1); // todo à vérifier

        const vgtMin = 20 * 60 * 1000;

        return diffMs > vgtMin;
    }

    getBase64 = file => {
        return new Promise(resolve => {
            let baseURL = '';

            let reader = new FileReader();

            reader.readAsDataURL(file);

            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            }
        })
    }

    dispMessages() {
        let prevHour = null;
        return this.state.messs.map((mess, key) => {
            // Définition de qui a envoyé le message
            let res = mess.admin;
            let isAdmin = true;
            if (res == null) {
                if (mess.user == null) {
                    res = "coord";
                } else {
                    res = mess.user
                    isAdmin = false;
                }
            }

            // Définition des dernières 20 minutes
            let newDate = null;
            if (res != "coord") {
                if (prevHour == null ) {
                    prevHour = res.date;
                    newDate = res.date;
                } else {
                    if (this.espaceTime20(res.date.date, prevHour.date)) {
                        prevHour = res.date;
                        newDate = res.date;
                    }
                }
            }
            return <>
                {/** Nouveaux message **/}
                {
                    res.isRead == false &&
                    <span className="tchat__nvmess">Nouveau message</span>
                }
                {/** Heure **/}
                {
                    newDate != null &&
                    <span className="tchat__hour">{dispDateHour(newDate.date)}</span>
                }
                {/** Message ou coordonnée **/}
                {
                    res == "coord" ?
                        <form className="tchat__coord">
                            <div className="tchat__inpgrp" title="Assurez-vous d'ajouter votre nom." aria-label="Assurez-vous d'ajouter votre nom.">
                                <label htmlFor="tchat-nom" className={`tchat__inplab ${(this.state.activeFocusName || this.state.formCoord.name != '') && "tchat__inplab--reduce"}`} id="lab-tchat-nom">Nom</label>
                                <input
                                    type="text"
                                    className="tchat__inp"
                                    id="tchat-nom"
                                    required
                                    value={this.state.formCoord.name}
                                    onFocus={() => {this.setState({activeFocusName: true})}}
                                    onBlur={() => {this.setState({activeFocusName: false})}}
                                    onChange={(el) => {
                                        this.setState(prevState => ({
                                            formCoord: {
                                                ...prevState.formCoord,
                                                name: el.target.value
                                            }
                                        }))
                                    }}
                                />
                            </div>
                            <div className="tchat__inpgrp" title="Assurez-vous d'ajouter votre adresse e-mail." aria-label="Assurez-vous d'ajouter votre adresse e-mail.">
                                <label htmlFor="tchat-email" className={`tchat__inplab ${(this.state.activeFocusEmail || this.state.formCoord.email) && "tchat__inplab--reduce"}`} id="lab-tchat-email">E-mail</label>
                                <input
                                    type="email"
                                    className="tchat__inp"
                                    id="tchat-email"
                                    required
                                    value={this.state.formCoord.email}
                                    onFocus={() => {this.setState({activeFocusEmail: true})}}
                                    onBlur={() => {this.setState({activeFocusEmail: false})}}
                                    onChange={(el) => {
                                        this.setState(prevState => ({
                                            formCoord: {
                                                ...prevState.formCoord,
                                                email: el.target.value
                                            }
                                        }))
                                    }}
                                />
                            </div>
                            <button
                                type="button"
                                className="tchat__btn"
                                title="Envoyer mes coordonnées"
                                aria-label="Envoyer mes coordonnées"
                                onClick={(el) => this.handleSaveCoord(el)}
                            >Ok</button>
                        </form> :
                        <div className={isAdmin ? "tchat__messdef" : "tchat__mess"}>
                            {/** Message **/}
                            {
                                res.file != null &&
                                <img src={`${getDomain()}image/tchat/${res.file}`} alt="Illustration liée au message" className="tchat__img" />
                            }
                            <p className={isAdmin ? "tchat__messdef__text" : "tchat__mess__text"}>
                                {res.message}
                            </p>
                        </div>
                }
                </>
        })
    }

    render() {
        return <div className={`ctc ${this.props.openMessage && "ctc--active"} dispAdmin`} id="contact">
            {/** Header **/}
            <header className="ctc__hdr">
                <div className="ctc__hdrlogo">
                    <img src={`${getDomain()}image/logo/${this.props.idtt.logo}`} alt={`Logo de ${this.props.idtt.name}`} className="ctc__logo" />
                    <span className="ctc__hdrlogoconn"></span>
                </div>
                <div className="ctc__hdrtxt">
                    <h2 className="ctc__ttl">{this.props.idtt.name}</h2>
                    <p className="ctc__desc" title="Nous vous répondrons dés que possible">Nous vous répondrons dès que possible</p>
                </div>
                <button
                    title="Fermer le tchat"
                    aria-label="Fermer le tchat"
                    className="ctc__hdrclose"
                    id="btn-close-contact"
                    onClick={() => this.props.handleTchat()}
                >
                    <FontAwesomeIcon icon={faXmark} />
                </button>
            </header>
            {/** Discussion **/}
            <div className="ctc__tchat tchat">
                {/** Partie par heure **/}
                <section className="tchat__grp">
                    {this.dispMessages()}
                </section>
            </div>
            {/** Ecris **/}
            <form className="ctc__form">
                {/** Bloc d'image **/}
                {
                    this.state.form.file != '' &&
                    <div className="ctc__formblocimg">
                        <button
                            title="Supprimer le fichier"
                            aria-label="Supprimer le fichier"
                            className="ctc__formimgbtn"
                            onClick={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        file: ''
                                    }
                                }))
                            }}
                        >
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                        <img src={this.state.form.file} alt="Illustration du message" className="ctc__formimg" />
                    </div>
                }
                <textarea
                    id="ctc-text"
                    className="ctc__formtxt"
                    placeholder="Rédigez votre message..."
                    value={this.state.form.message}
                    onChange={(el) => {
                        this.setState(prevState => ({
                            form: {
                                ...prevState.form,
                                message: el.target.value
                            }
                        }))
                    }}
                ></textarea>
                <div className="ctc__formbtns">
                    <label
                        title="Envoyer une pièce jointe"
                        aria-label="Envoyer une pièce jointe"
                        className="ctc__formbtn"
                        htmlFor="btn-ctc-pj"
                    >
                        <FontAwesomeIcon icon={faImage} />
                    </label>
                    <input
                        type="file"
                        accept="image/*"
                        style={{display: "none"}}
                        className="ctc__formfile"
                        id="btn-ctc-pj"
                        onChange={(el) => {
                            this.getBase64(el.target.files[0])
                                .then(result => {
                                    el.target.files[0]["base64"] = result;

                                    this.setState(
                                        prevState => ({
                                            form: {
                                                ...prevState.form,
                                                file: result
                                            }
                                        })
                                    )
                                })
                                .catch(err => {console.log(err)})
                        }}
                    />
                    <button
                        title="Envoyer le message"
                        aria-label="Envoyer le message"
                        className="ctc__formbtn ctc__formbtn--send"
                        id="btn-ctc-send"
                        onClick={(el) => this.handleSend(el)}
                    >
                        <FontAwesomeIcon icon={faPaperPlane} />
                    </button>
                </div>
            </form>
        </div>
    }
}

const mapStateToProps = state => {
    return {
        redSendCtct: state.redSendCtct,
        redSaveCoord: state.redSaveCoord,
        redListCtct: state.redListCtct
    }
}

const mapDispatchToProps = {
    sendContact,
    saveCoord,
    getContact
}

export default connect(mapStateToProps, mapDispatchToProps)(Tchat);

// todo : vérifier --> lors d'un envoi de message, est-ce que on va chercher dans la bdd si l'ip a déjà envoyé un message et que le nom dliéà cette ip est mise à jour avec le message créé ?